import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { InputItemType } from '../../types';

@Component({
  selector: 'render-city-row',
  templateUrl: './render-city-row.component.html',
  styleUrls: ['./render-city-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenderCityRowComponent {
  @Input() city?: InputItemType;
}
